import React from 'react';
import IconWrapper from '../IconWrapper';
const CloseIcon = (props) => {
    const brand = process.env.BRAND || process.env.BRAND_PREFIX;
    switch (brand) {
        case 'cos':
            return (React.createElement(IconWrapper, Object.assign({}, props, { viewBox: "0 0 11 10" }),
                React.createElement("path", { d: "M10.667 0.875L9.79199 0L5.66699 4.125L1.54199 0L0.666992 0.875L4.79199 5L0.666992 9.125L1.54199 10L5.66699 5.875L9.79199 10L10.667 9.125L6.54199 5L10.667 0.875Z" })));
        case 'weekday':
            return (React.createElement(IconWrapper, Object.assign({}, props, { viewBox: "0 0 18 18" }),
                React.createElement("path", { d: "M9 7.531L15.796.735 16.531 0 18 1.469l-.735.735L10.47 9l6.796 6.796.735.735L16.531 18l-.735-.735L9 10.47l-6.796 6.796-.735.735L0 16.531l.735-.735L7.53 9 .735 2.204 0 1.469 1.469 0l.735.735L9 7.53z" })));
        case 'monki':
            return (React.createElement(IconWrapper, Object.assign({}, props),
                React.createElement("path", { d: "m13.414 12 9.293-9.293-1.414-1.414L12 10.586 2.707 1.293 1.293 2.707 10.586 12l-9.293 9.293 1.414 1.414L12 13.414l9.293 9.293 1.414-1.414L13.414 12Z" })));
        case 'arket':
            return (React.createElement(IconWrapper, Object.assign({}, props),
                React.createElement("path", { d: "m2.073.586 22.513 22.513-1.487 1.487L.586 2.073 2.073.586Z" }),
                React.createElement("path", { d: "M23.099.586.586 23.099l1.487 1.487L24.586 2.073 23.099.586Z" })));
        default:
            return (React.createElement(IconWrapper, Object.assign({}, props),
                React.createElement("path", { d: "M12 11.29L21.29 2l.71.71L12.71 12 22 21.29l-.71.71L12 12.71 2.71 22 2 21.29 11.29 12 2 2.71 2.71 2 12 11.29z" })));
    }
};
export default CloseIcon;
//# sourceMappingURL=CloseIcon.js.map